<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Tiendas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogImport = true">
            Importar
            <v-icon right>mdi-arrow-up</v-icon>
          </v-btn>
          <download-csv v-show="false" ref="export" :data="export_data" name="tiendas.csv"></download-csv>
          <v-btn text small :disabled="loading" @click="exportData()">
            Exportar
            <v-icon right>mdi-arrow-down</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogFilters = true">
            Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="showRelations()">
            Relaciones
            <v-icon right>mdi-merge</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:item.promotor="{ item }">
            {{ getName(item.promotor, 'promotores') }}
          </template>
          <template v-slot:item.supervisor="{ item }">
            {{ getName(item.supervisor, 'supervisores') }}
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogFilters" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="clearFilters()">
              Reiniciar
              <v-icon right>mdi-minus</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="closeFilters()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="setFilters()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.plaza" :items="plazas" item-value="id" item-text="nombre" label="Plaza" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.promotor" :items="promotores" item-value="id" item-text="nombre" label="Promotor" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.supervisor" :items="supervisores" item-value="id" item-text="nombre" label="Supervisor" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.cadena_comercial" label="Cadena comercial" :rules="formRules.cadena_comercial" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.latitud" label="Latitud" :rules="formRules.latitud" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.longitud" label="Longitud" :rules="formRules.longitud" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="formNew.promotor" :items="promotores" item-value="id" item-text="nombre" label="Promotor" :rules="formRules.supervisor" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="formNew.supervisor" :items="supervisores" item-value="id" item-text="nombre" label="Supervisor" :rules="formRules.promotor" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.calle" label="Calle" :rules="formRules.calle" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.numero" label="Numero" :rules="formRules.numero" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.colonia" label="Colonia" :rules="formRules.colonia" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.ciudad" label="Ciudad" :rules="formRules.ciudad" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.estado" label="Estado" :rules="formRules.estado" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.pais" label="Pais" :rules="formRules.pais" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.idexterno2" label="Idexterno2" :rules="formRules.idexterno2" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formNew.numero_cliente" label="Número de Cliente" :rules="formRules.numero_cliente" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formNew.territorio" label="Territorio" :rules="formRules.territorio" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select v-model="formUpdate.heets" :items="heets" label="Heets" :rules="formRules.heets" :disabled="loading" required></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.cadena_comercial" label="Cadena comercial" :rules="formRules.cadena_comercial" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.descripcion" label="Descripción" :rules="formRules.descripcion" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.latitud" label="Latitud" :rules="formRules.latitud" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.longitud" label="Longitud" :rules="formRules.longitud" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="formUpdate.promotor" :items="promotores" item-value="id" item-text="nombre" label="Promotor" :rules="formRules.supervisor" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="formUpdate.supervisor" :items="supervisores" item-value="id" item-text="nombre" label="Supervisor" :rules="formRules.promotor" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.calle" label="Calle" :rules="formRules.calle" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.numero" label="Numero" :rules="formRules.numero" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.colonia" label="Colonia" :rules="formRules.colonia" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.ciudad" label="Ciudad" :rules="formRules.ciudad" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.estado" label="Estado" :rules="formRules.estado" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.pais" label="Pais" :rules="formRules.pais" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.idexterno2" label="Idexterno2" :rules="formRules.idexterno2" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formUpdate.numero_cliente" label="Número de Cliente" :rules="formRules.numero_cliente" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formUpdate.territorio" label="Territorio" :rules="formRules.territorio" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select v-model="formUpdate.heets" :items="heets" label="Heets" :rules="formRules.heets" :disabled="loading" required></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRelations" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Relaciones Tiendas/Empresas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelRelations()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="pt-5" >
              <v-col>
                <v-card class="elevation-5">
                  <v-toolbar dense dark color="deep-orange" elevation="2">
                    <v-toolbar-title>{{ selected.length && selected[0].nombre }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn text small :disabled="loading" @click="dialogImportRels = true">
                      Importar
                      <v-icon right>mdi-arrow-up</v-icon>
                    </v-btn>
                    <download-csv v-show="false" ref="relsExport" :data="export_rels_data" name="relaciones.csv"></download-csv>
                    <v-btn text small :disabled="loading" @click="exportRelsData()">
                      Exportar
                      <v-icon right>mdi-arrow-down</v-icon>
                    </v-btn>
                    <v-btn text small :disabled="loading" @click="dialogRelsNew = true">
                      Agregar
                      <v-icon right>mdi-plus</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title>
                    <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refreshRelations()">
                      Actualizar
                      <v-icon right>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn small :disabled="!rels.selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="viewRelation()">
                      Editar
                      <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small :disabled="!rels.selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRelsRemove = true">
                      Eliminar
                      <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="rels.search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
                  </v-card-title>
                  <v-data-table v-model="rels.selected" :headers="rels.headers" :items="rels.items" :loading="loading" :search="rels.search"
                  :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
                  single-select show-select class="elevation-1">
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template v-slot:item.tienda="{ item }">
                      {{ getRelsName(item.tienda, 'tiendas') }}
                    </template>
                    <template v-slot:item.empresa="{ item }">
                      {{ getRelsName(item.empresa, 'empresas') }}
                    </template>
                    <template v-slot:item.plaza="{ item }">
                      {{ getRelsName(item.plaza, 'plazas') }}
                    </template>
                    <template v-slot:item.subdireccion="{ item }">
                      {{ getRelsName(item.subdireccion, 'subdirecciones') }}
                    </template>
                    <template v-slot:item.gerencia="{ item }">
                      {{ getRelsName(item.gerencia, 'gerencias') }}
                    </template>
                    <template v-slot:item.opciones="{ item }">
                      {{ item.opciones.length }}
                    </template>
                    <template v-slot:footer.page-text="props">
                      Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                    </template>
                    <template v-slot:no-data>
                      No hay información disponible
                    </template>
                    <template v-slot:no-results>
                      No se obtuvieron resultados
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRelsNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelRelsForms()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="saveRelation()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formRelsNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formRelsNew.idrelacion" label="Idrelacion" :rules="formRules.rels.idrelacion"
                    :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsNew.empresa" :items="rels.empresas" item-value="id" item-text="idexterno"
                    label="Empresa" :rules="formRules.rels.empresa" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsNew.plaza" :items="rels.plazas" item-value="id" item-text="idexterno"
                    label="Plaza" :rules="formRules.rels.plaza" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsNew.subdireccion" :items="rels.subdirecciones" item-value="id" item-text="nombre"
                    label="Subdirección" :rules="formRules.rels.subdireccion" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsNew.gerencia" :items="rels.gerencias" item-value="id" item-text="nombre"
                    label="Gerencia" :rules="formRules.rels.gerencia" :disabled="loading" required></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRelsUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelRelsForms()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateRelation()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formRelsUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formRelsUpdate.idrelacion" label="Idrelacion" :rules="formRules.rels.idrelacion"
                    :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsUpdate.empresa" :items="rels.empresas" item-value="id" item-text="idexterno"
                    label="Empresa" :rules="formRules.rels.empresa" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsUpdate.plaza" :items="rels.plazas" item-value="id" item-text="idexterno"
                    label="Plaza" :rules="formRules.rels.plaza" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsUpdate.subdireccion" :items="rels.subdirecciones" item-value="id" item-text="nombre"
                    label="Subdirección" :rules="formRules.rels.subdireccion" :disabled="loading" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="formRelsUpdate.gerencia" :items="rels.gerencias" item-value="id" item-text="nombre"
                    label="Gerencia" :rules="formRules.rels.gerencia" :disabled="loading" required></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRelsRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancelRelsForms()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="removeRelation()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImport" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Importar registros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelImport()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="acceptImport()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input v-model="importFile.id" chips show-size label="Tiendas" :disabled="loading"></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="importFile.header" label="Ignorar la primera fila" :disabled="loading"></v-switch>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImportRels" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Importar registros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelImportRels()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="acceptImportRels()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input v-model="importFileRels.id" chips show-size label="Relaciones Tiendas/Empresas" :disabled="loading"></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-switch v-model="importFileRels.header" label="Ignorar la primera fila" :disabled="loading"></v-switch>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import services from '@/utils/services'
import jsoncsv from 'vue-json-csv'

Vue.component('download-csv', jsoncsv)

export default {
  name: 'tiendas',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Cadena comercial', align: 'center', sortable: false, value: 'cadena_comercial' },
      { text: 'Descricpión', align: 'center', sortable: false, value: 'descripcion' },
      { text: 'Promotor', align: 'center', sortable: false, value: 'promotor' },
      { text: 'Supervisor', align: 'center', sortable: false, value: 'supervisor' },
      { text: 'Idexterno', align: 'center', sortable: false, value: 'idexterno' },
      { text: 'Idexterno2', align: 'center', sortable: false, value: 'idexterno2' },
    ],
    items: [],
    plazas: [],
    promotores: [],
    supervisores: [],
    selected: [],
    export_data: [],
    export_rels_data: [],
    heets: ['SI', 'NO'],
    filters: {
      plaza: '',
      promotor: '',
      supervisor: ''
    },
    rels: {
      search: '',
      headers: [
        { text: 'Idrelacion', align: 'center', sortable: false, value: 'idrelacion' },
        { text: 'Tienda', align: 'center', sortable: false, value: 'tienda' },
        { text: 'Empresa', align: 'center', sortable: false, value: 'empresa' },
        { text: 'Plaza', align: 'center', sortable: false, value: 'plaza' },
        { text: 'Subdirección', align: 'center', sortable: false, value: 'subdireccion' },
        { text: 'Gerencia', align: 'center', sortable: false, value: 'gerencia' },
        { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
      ],
      items: [],
      selected: [],
      tiendas: [],
      empresas: [],
      plazas: [],
      subdirecciones: [],
      gerencias: []
    },
    importFile: {
      id: null,
      header: false
    },
    importFileRels: {
      id: null,
      header: false
    },
    dialogFilters: false,
    dialogNew: false,
    dialogUpdate: false,
    dialogRemove: false,
    dialogRelations: false,
    dialogRelsNew: false,
    dialogRelsUpdate: false,
    dialogRelsRemove: false,
    dialogImport: false,
    dialogImportRels: false,
    formNew: {
      nombre: '',
      cadena_comercial: '',
      descripcion: '',
      latitud: '',
      longitud: '',
      promotor: '',
      supervisor: '',
      calle: '',
      numero: '',
      colonia: '',
      ciudad: '',
      estado: '',
      pais: '',
      idexterno: '',
      idexterno2: '',
      numero_cliente: '',
      territorio: '',
      heets: ''
    },
    formUpdate: {
      id: '',
      nombre: '',
      cadena_comercial: '',
      descripcion: '',
      latitud: '',
      longitud: '',
      promotor: '',
      supervisor: '',
      calle: '',
      numero: '',
      colonia: '',
      ciudad: '',
      estado: '',
      pais: '',
      idexterno: '',
      idexterno2: '',
      numero_cliente: '',
      territorio: '',
      heets: ''
    },
    formRelsNew: {
      idrelacion: '',
      empresa: '',
      plaza: '',
      subdireccion: '',
      gerencia: '',
    },
    formRelsUpdate: {
      id: '',
      idrelacion: '',
      empresa: '',
      plaza: '',
      subdireccion: '',
      gerencia: '',
    },
    formRules: {
      nombre: [
        v => !!v || 'El nombre es obligatorio',
        v => (v && v.length <= 150) || 'El nombre excede la longitud máxima'
      ],
      cadena_comercial: [
        v => !!v || 'La cadena comercial es obligatoria',
        v => (v && v.length <= 150) || 'La cadena comercial excede la longitud máxima'
      ],
      descripcion: [
        v => (v || '').length <= 250 || 'La descripción excede la longitud máxima'
      ],
      latitud: [
        v => (v || '').length <= 50 || 'La latitud excede la longitud máxima',
        v => v === '' || /^-?\d+\.?\d*$/.test(v) || 'La latitud es inválida'
      ],
      longitud: [
        v => (v || '').length <= 50 || 'La longitud excede la longitud máxima',
        v => v === '' || /^-?\d+\.?\d*$/.test(v) || 'La longitud es inválida'
      ],
      promotor: [
        v => !!v || 'El promotor es obligatorio',
      ],
      supervisor: [
        v => !!v || 'El supervisor es obligatorio',
      ],
      calle: [
        v => (v || '').length <= 50 || 'La calle excede la longitud máxima'
      ],
      numero: [
        v => (v || '').length <= 50 || 'El número excede la longitud máxima'
      ],
      colonia: [
        v => (v || '').length <= 50 || 'La colonia excede la longitud máxima'
      ],
      ciudad: [
        v => (v || '').length <= 50 || 'La ciudad excede la longitud máxima'
      ],
      estado: [
        v => (v || '').length <= 50 || 'El estado excede la longitud máxima'
      ],
      pais: [
        v => (v || '').length <= 50 || 'El país excede la longitud máxima'
      ],
      idexterno: [
        v => (v || '').length <= 150 || 'El idexterno excede la longitud máxima'
      ],
      idexterno2: [
        v => (v || '').length <= 150 || 'El idexterno2 excede la longitud máxima'
      ],
      numero_cliente: [
        v => (v || '').length <= 150 || 'El número de cliente excede la longitud máxima'
      ],
      territorio: [
        v => (v || '').length <= 150 || 'El territorio excede la longitud máxima'
      ],
      heets: [
        v => (v || '').length <= 20 || 'La heets excede la longitud máxima'
      ],
      rels: {
        idrelacion: [
          v => !!v || 'El idrelacion es obligatorio',
          v => (v && v.length <= 50) || 'El idrelacion excede la longitud máxima'
        ],
        empresa: [
          v => !!v || 'La empresa es obligatoria',
        ],
        plaza: [
          v => !!v || 'La plaza es obligatoria',
        ],
        subdireccion: [
          v => !!v || 'La subdirección es obligatoria',
        ],
        gerencia: [
          v => !!v || 'La gerencia es obligatoria',
        ],
      }
    }
  }),
  mounted() {
    this.refresh()
    this.dialogFilters = true
  },
  methods: {
    refresh() {
      this.loading = true
      let data = {
        filtros: JSON.stringify(this.filters)
      }
      services.ws('get', 'tiendas', data)
        .then(res => {
          if (res.ok) {
            this.items = res.data.tiendas
            this.plazas = res.data.plazas
            this.supervisores = res.data.supervisores
            this.promotores = res.data.promotores
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearFilters() {
      for (let key in this.filters) {
        this.filters[key] = ''
      }
    },
    closeFilters() {
      this.dialogFilters = false
    },
    setFilters() {
      if (this.filters.plaza !== '' || this.filters.promotor !== '' || this.filters.supervisor !== '') {
        this.loading = true
        let data = {
          filtros: JSON.stringify(this.filters)
        }
        services.ws('get', 'tiendas', data)
          .then(res => {
            if (res.ok) {
              this.items = res.data.tiendas
              this.plazas = res.data.plazas
              this.supervisores = res.data.supervisores
              this.promotores = res.data.promotores
              this.selected = []
              this.closeFilters()
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'Debe establecer al menos un filtro'
      }
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      for (let key in this.formNew) {
        this.formNew[key] = ''
      }
      for (let key in this.formUpdate) {
        this.formUpdate[key] = ''
      }
    },
    cancel() {
      this.clear()
      this.selected = []
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogRemove = false
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevaTienda', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarTienda', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarTienda', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    getName(id, key) {
      for (let i = 0; i < this[key].length; i++) {
        if (this[key][i].id == id) {
          return this[key][i].nombre
        }
      }
      return null
    },
    showRelations() {
      this.loading = true
      let data = {
        id: this.selected[0].id
      }
      services.ws('get', 'relsTiendasEmpresas', data)
        .then(res => {
          if (res.ok) {
            this.rels.items = res.data.relaciones
            this.rels.tiendas = res.data.tiendas
            this.rels.empresas = res.data.empresas
            this.rels.plazas = res.data.plazas
            this.rels.subdirecciones = res.data.subdirecciones
            this.rels.gerencias = res.data.gerencias
            this.dialogRelations = true
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false 
        })
    },
    refreshRelations() {
      this.loading = true
      let data = {
        id: this.selected[0].id
      }
      services.ws('get', 'relsTiendasEmpresas', data)
        .then(res => {
          if (res.ok) {
            this.rels.items = res.data.relaciones
            this.rels.tiendas = res.data.tiendas
            this.rels.empresas = res.data.empresas
            this.rels.plazas = res.data.plazas
            this.rels.subdirecciones = res.data.subdirecciones
            this.rels.gerencias = res.data.gerencias
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false 
        })
    },
    clearRelations() {
      for (let key in this.formRelsNew) {
        this.formRelsNew[key] = ''
      }
      for (let key in this.formRelsUpdate) {
        this.formRelsUpdate[key] = ''
      }
      if (this.$refs.formRelsNew) {
        this.$refs.formRelsNew.reset()
      }
      else if (this.$refs.formRelsUpdate) {
        this.$refs.formRelsUpdate.reset()
      }
    },
    cancelRelations() {
      this.clearRelations()
      this.rels.search = ''
      this.rels.items = []
      this.rels.selected = []
      this.dialogRelations = false
    },
    cancelRelsForms() {
      this.clearRelations()
      this.rels.selected = []
      this.dialogRelsNew = false
      this.dialogRelsUpdate = false
      this.dialogRelsRemove = false
    },
    saveRelation() {
      if (this.$refs.formRelsNew.validate()) {
        this.loading = true
        setTimeout(() => {
          let data = {
            idrelacion: this.formRelsNew.idrelacion,
            tienda: this.selected[0].id,
            empresa: this.formRelsNew.empresa,
            plaza: this.formRelsNew.plaza,
            subdireccion: this.formRelsNew.subdireccion,
            gerencia: this.formRelsNew.gerencia
          }
          services.ws('post', 'nuevaRelTiendaEmpresa', data)
            .then(res => {
              if (res.ok) {
                this.cancelRelsForms()
                this.refreshRelations()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    viewRelation() {
      this.formRelsUpdate = JSON.parse(JSON.stringify(this.rels.selected[0]))
      this.dialogRelsUpdate = true
    },
    updateRelation() {
      if (this.$refs.formRelsUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          let data = {
            id: this.formRelsUpdate.id,
            idrelacion: this.formRelsUpdate.idrelacion,
            empresa: this.formRelsUpdate.empresa,
            plaza: this.formRelsUpdate.plaza,
            subdireccion: this.formRelsUpdate.subdireccion,
            gerencia: this.formRelsUpdate.gerencia
          }
          services.ws('post', 'actualizarRelTiendaEmpresa', data)
            .then(res => {
              if (res.ok) {
                this.cancelRelsForms()
                this.refreshRelations()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    removeRelation() {
      this.loading = true
      setTimeout(() => {
        let id = this.rels.selected[0].id
        services.ws('post', 'eliminarRelTiendaEmpresa', { id })
          .then(res => {
            if (res.ok) {
              this.cancelRelsForms()
              this.refreshRelations()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    getRelsName(id, key) {
      for (let i = 0; i < this.rels[key].length; i++) {
        if (this.rels[key][i].id == id) {
          return this.rels[key][i].idexterno
        }
      }
      return null
    },
    cancelImport() {
      this.importFile.id = null
      this.importFile.header = false
      this.dialogImport = false
    },
    acceptImport() {
      if (this.importFile.id) {
        let fr = new FileReader();
        let file = this.importFile.id
        let size = this.importFile.id.size
        if (size <= 10000000) {
          fr.onload = () => {
            this.loading = true
            let data = {
              file: fr.result,
              header: this.importFile.header
            }
            services.ws('post', 'importarTiendas', data)
              .then(res => {
                if (res.ok) {
                  this.cancelImport()
                  this.cancel()
                  this.refresh()
                  this.success = true
                  this.msgSuccess = res.message
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          fr.onerror = () => {
            this.importFile.id = null
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(this.importFile.id);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un archivo'
      }
    },
    cancelImportRels() {
      this.importFileRels.id = null
      this.importFileRels.header = false
      this.dialogImportRels = false
    },
    acceptImportRels() {
      if (this.importFileRels.id) {
        let fr = new FileReader();
        let file = this.importFileRels.id
        let size = this.importFileRels.id.size
        if (size <= 10000000) {
          fr.onload = () => {
            this.loading = true
            let data = {
              file: fr.result,
              header: this.importFileRels.header
            }
            services.ws('post', 'importarRelsTiendasEmpresas', data)
              .then(res => {
                if (res.ok) {
                  this.cancelImportRels()
                  this.cancelRelations()
                  this.refresh()
                  this.success = true
                  this.msgSuccess = res.message
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          fr.onerror = () => {
            this.importFileRels.id = null
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(this.importFileRels.id);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un archivo'
      }
    },
    exportData() {
      this.loading = true
      services.ws('get', 'totalTiendas')
        .then(res => {
          if (res.ok) {
            this.export_data = res.data.tiendas
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.$refs.export.$el.click()
          this.loading = false
        })
    },
    exportRelsData() {
      this.loading = true
      let data = {
        id: this.selected[0].id
      }
      services.ws('get', 'totalRelsTiendasEmpresas', data)
        .then(res => {
          if (res.ok) {
            this.export_rels_data = res.data.relaciones
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.$refs.relsExport.$el.click()
          this.loading = false
        })
    }
  }
}
</script>
